import axios from "axios";
import { rootPath ,} from "@/utils/globalParam";
import { Message } from "element-ui";
import store from '../store/index';
export default async (fileName, param = {}, url) => {
  let deal = res => {
    //返回结果为空
    if (!res) {
      Message.error("发生错误！请重新操作");
      return;
    }
    //返回结果不是200，抛出错误提示debugger
    if (res.status != "200") {
      Message.error("请求发生错误，请联系管理员");
      return;
    }
    const content = res.data;
    const blob = new Blob([content]);
    if ("download" in document.createElement("a")) {
      // 非IE下载
      const elink = document.createElement("a");
      elink.download = fileName;
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, fileName);
    }
  };

  let formParams = new URLSearchParams();
  for (let key in param) {
    formParams.append(key, param[key]);
  }
  return axios
    .get(url, {
       params: formParams,
       responseType: "blob",
       baseURL: rootPath,
       timeout: 10000,
       withCredentials: true, // 是否允许带cookie这些
       headers: {
        // "content-Type": "multipart/form-data",
        // access_token: store.state.tokenInfo.access_token,
        // tenantId: store.state.tokenInfo.tenantId,
        // funcId: store.state.tokenInfo.funcId,
        authorization:store.state.user.user.authorization,
        tenantId:store.state.user.user.tenantId
      },
    },)
    .then(deal);
};
